import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from './Title';
import {getCurrentDate} from '../Utils/Date'
import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbUpDown from '@material-ui/icons/ThumbsUpDown';
import { green } from '@material-ui/core/colors';
import { amber } from '@material-ui/core/colors';

function preventDefault(event) {
  event.preventDefault();
}

const useStyles = makeStyles({
  statusContext: {
    flex: 1,
  },
});

export default function Status() {
  const classes = useStyles();
  
  return (
    <React.Fragment>
      <Title>Tools Status</Title>
      <Typography>
        Jenkins  <ThumbUp fontSize="small" style={{ color: green[500], paddingTop: 5,  }}/>
      </Typography>
      <Typography>
        Bitbucket  <ThumbUp fontSize="small" style={{ color: green[500], paddingTop: 5,  }}/>
      </Typography>
      <Typography>
        Regression Env  <ThumbUpDown fontSize="small" style={{ color: amber[500], paddingTop: 2,  }}/>
      </Typography>
      <Typography color="textSecondary" className={classes.statusContext}>
        {getCurrentDate("-")}
      </Typography>
      <div>
        <Link color="primary" href="#" onClick={preventDefault}>
          View Issues
        </Link>
      </div>
    </React.Fragment>
  );
}
